
import { Component, Vue, Watch } from 'vue-property-decorator';
import CreateProfile from '@/components/CreateProfile.vue';
import ComparePanel from '@/components/ComparePanel.vue';
import ChartCol from '@/components/ChartCol.vue';
import _ from 'lodash';
import UtilsService from '@/services/utils.service';
import Env from '@/services/env.service';
import GAService from '@/services/ga.service';
import { AsOf, Profile, Bucket, BucketMap } from '../store/types';

@Component({
  components: {
    CreateProfile,
    ComparePanel,
    ChartCol
  },
})
export default class Calculator extends Vue {

  public selectedProfileId: number = -1;

  public test() {
    console.log(process.env.VUE_APP_TEST);
  }

  get profilesLoading() {
    return this.$store.state.profiles.profilesLoading;
  }

  get profiles(): Profile[] {
    return this.$store.state.profiles.profiles;
  }

  get loadedProfile() {
    return this.$store.state.profiles.loadedProfile;
  }

  get isLoadingFromProfile() {
    return this.$store.state.selections.isLoadingFromProfile;
  }

  get isSpecialMode() {
    return Env.get("VUE_APP_NAMESPACE") ? true : false;
  }
   get dataVersionText() {
    return Env.get("VUE_APP_NAMESPACE");
  }

  get profileHasBeenChanged() {
    if (!_.isEmpty(this.selectedProfile) && !this.isLoadingFromProfile) {
      // We have a selected profile, so let's see if it's been edited
      // 1. Check products match
      if (UtilsService.compareArrays(this.selectedProducts, this.selectedProfile.types)) {
        return true;
      }
      // 2. Check data sources match
      if (UtilsService.compareArrays(this.selectedDataSources, this.selectedProfile.sources)) {
        return true;
      }
      // 3. Check attributes match
      if (UtilsService.compareArrays(this.selectedAttributes, this.selectedProfile.attributes)) {
        return true;
      }
      // 4. Check buckets match
      for (const attrId in this.selectedProfile.buckets || {}) {
        const original: Bucket = this.selectedProfile.buckets[attrId];
        const current: Bucket =  this.$store.getters.getBucketingForAttribute(attrId);

        if (!_.isEqual(current, original)) {
          return true;
        }
      }

      // 5. Check as of dates
      if (this.selectedProfile.asOf &&
        (this.selectedProfile.asOf !== this.asOf)) {
        return true;
      }
    }
    return false;
  }



  /**
   * Keeping track of the current selections
   */

  get selectedProducts() {
    return this.$store.state.selections.selectedProducts || [];
  }

  get selectedDataSources() {
    return this.$store.state.selections.selectedDataSources || [];
  }

  get selectedAttributes() {
    return this.$store.state.selections.selectedAttributes || [];
  }

  get selectedBucketing() {
    return this.$store.state.buckets.selectedBucketing || '';
  }

  get selectedProfile() {
    return this.$store.state.profiles.selectedProfile || '';
  }

  public get calculateDisabled() {
    if (this.selectedProducts.length && this.selectedDataSources.length && this.selectedAttributes.length) {
      return false;
    }
    return true;
  }

/**
 * Options - to populate lists / dropdowns
 */
  public get optionsData() {
    return this.$store.state.options.options || {};
  }

  public get productsById() {
    return this.$store.state.options.productsById || {};
  }

  public get asOf(): AsOf {
    return this.$store.getters.getAsOf;
  }

  @Watch('selectedProfileId')
  private onPropertyChanged(value: number, oldValue: number) {
    // TODO: maybe delete loaded profile...
    const profile = this.profiles.find((obj) => obj.id === value);
    this.$store.commit('setSelectedProfile', profile);
    if (profile) {
      GAService.sendEvent(this.$gtag, 'Calculate', 'Profile', '');
      GAService.sendEvent(this.$gtag, 'Profile', 'Loaded', profile.name);
      this.$store.dispatch('populateFromProfile', profile);
    }
  }

  @Watch('selectedProfile')
  private onSelectedProfileChanged(value: string, oldValue: string) {
    if (!value || (value && _.isEmpty(value))) {
      this.selectedProfileId = -1;
    }
  }

  @Watch('loadedProfile')
  private onLoadedProfileChanged(value: any, oldValue: any) {
    if (value && !_.isEmpty(value)) {
      this.selectedProfileId = value.id;
    }
  }

  public clearSelections() {
    this.selectedProfileId = -1;
    this.$store.dispatch('clearSelections');
  }

  public async saveAsProfile() {
    const buckets: BucketMap = this.selectedAttributes
      .filter((attrId: string): boolean => {
        const fullAttr: any = this.optionsData.attributes.find((attr: any): boolean => attr.id === attrId);
        return fullAttr && fullAttr.fixed_order;
      })
      .reduce((map: BucketMap, attrId: string): BucketMap => {
        map[attrId] = this.$store.getters.getBucketingForAttribute(attrId);
        return map;
      }, {});

    const profile: Profile = {
      sources: this.selectedDataSources,
      types: this.selectedProducts,
      attributes: this.selectedAttributes,
      buckets,
      asOf: this.asOf,
      name: this.selectedProfile && this.selectedProfile.name ? this.selectedProfile.name : '',
      id: this.selectedProfile && this.selectedProfile.id ? this.selectedProfile.id : null
    };

    this.$store.commit('setProfileToSave', profile);
    this.$store.commit('setModal', 'saveAsProfile');
  }

  public async deleteProfile() {
    if (this.selectedProfile && !_.isEmpty(this.selectedProfile)) {
      this.$store.commit('setProfileToDelete', this.selectedProfile);
      this.$store.commit('setModal', 'deleteProfile');
    }


  }

  public mounted() {
    this.$store.dispatch('getCustomBuckets');
    this.$store.dispatch('getProfiles');
  }
}
